import React, {useContext, useEffect, useState} from "react";
import { Link } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import {
    Box,
    Button,
    Container,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    Typography, useToastProvider
} from '@deere/fuel-react';
import { checkedData, searchWithDescList } from "../shared/utils";
import {useAuthConfig} from "../shared/helper";
import SearchIcon from "@material-ui/icons/Search";
import { useOktaAuth } from '@okta/okta-react';
import { Loading } from "../shared/Loading";
import SupplierMaintenanceList from "./SupplierMaintenanceList"
import { Supplier } from "./Supplier";
import { SupplierFilter } from "../shared/filter/SupplierFilter";
import FunctionalAreaFilter from "../shared/filter/FunctionalAreaFilter";
import {UserContext} from "./Main";

export const SupplierMaintenance = ({ name }) => {
    let authAxios = useAuthConfig();
    const info = useContext(UserContext);
    const isAdmin = info && info.isCriteriaAdmin;
    const { authState } = useOktaAuth();
    const {enqueueToast} = useToastProvider();
    const [isLoading, setIsLoading] = useState(false);
    const [supplierMaintenanceList, setSupplierMaintenanceList] = useState(null);
    const [filterList, setFilterList] = useState(null);
    const [selectedSuppliers, setSelectedSuppliers] = useState([]);
    const [expandedSupplier, setExpandedSupplier] = React.useState(true);
    const [searchParam] = useState(["supplierName", "supplierNumber", "status"]);
    const [searchParamDesc] = useState(["functionalArea", "subFunctionalArea"]);
    const [query, setQuery] = useState("");
    const [functionalAreaData, setFunctionalAreaData] = useState([]);
    const [functionalAreaFilterData, setFunctionalAreaFilterData] = useState([]);
    const [functionalAreaExpanded, setFunctionalAreaExpanded] = useState(false);
    const [subFunctionalAreaData, setSubFunctionalAreaData] = useState([]);
    const [subFunctionalAreaFilterData, setSubFunctionalAreaFilterData] = useState([]);
    const [subFunctionalAreaExpanded, setSubFunctionalAreaExpanded] = useState(false);

    const getSupplierMaintenanceComponent = (list) => {
        return list.map((item) => {
            return (
                <Supplier supplierData={item} key={item.id} isAdmin={isAdmin} />
            );
        });
    }

    const getSupplierMaintenanceList = async () => {
        setIsLoading(true)
        try {
            return await authAxios.get(`/supplierMnt`);
        } catch (e) {
            enqueueToast({
                variant: "error",
                title: "System Error",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        }
    };

    const processSupplierMaintenance = (response) => {
        const updatedData = response.map((row) => {
            const status = { status: `${row.aeSupplierInd}` === 'Y' ? "Yes" : "No" }
            row = { ...status, ...row };
            return row;
        });
        const functionalAreas = updatedData.map(item => {
            return item.functionalArea.description
        });
        const uniqueFunctionalAreas = ([...new Set([].concat(...functionalAreas))])

        const subFunctionalAreas = updatedData.map(item => {
            return item.subFunctionalArea.description
        });
        const uniqueSubFunctionalAreas = ([...new Set([].concat(...subFunctionalAreas))])

        setFunctionalAreaData(uniqueFunctionalAreas)
        setFunctionalAreaFilterData(uniqueFunctionalAreas)
        setSubFunctionalAreaData(uniqueSubFunctionalAreas)
        setSubFunctionalAreaFilterData(uniqueSubFunctionalAreas)
        setIsLoading(false);
        const list = getSupplierMaintenanceComponent(updatedData);
        setSupplierMaintenanceList(list)
        setFilterList(list);
    }

    const resetFilter = () => {
        setSelectedSuppliers([])
        sessionStorage.setItem("selectedSuppliers", JSON.stringify([]));
        setFunctionalAreaFilterData(functionalAreaData);
        setSubFunctionalAreaFilterData(subFunctionalAreaData);
    }

    const handleChangeSupplier = (panel) => (event, isExpanded) => {
        setExpandedSupplier(isExpanded ? panel : false);
    };

    const handleSupplierChange = (event) => {
        setSelectedSuppliers(event);
    }

    const toggleFunctionalAreaFilter = () => {
        setFunctionalAreaExpanded(!functionalAreaExpanded);
    };

    const toggleSubFunctionalAreaFilter = () => {
        setSubFunctionalAreaExpanded(!subFunctionalAreaExpanded);
    };

    const handleUpdatedFuncionalArea = data => {
        const arr = checkedData(data)
        const filteredCategories = supplierMaintenanceList.filter(item => arr.includes(item.props.supplierData.functionalArea.description))
        const subcategoriesData = filteredCategories.map(item => {
            return item.props.supplierData.subFunctionalArea.description
        })
        setFunctionalAreaFilterData(arr);
        setSubFunctionalAreaFilterData(subcategoriesData);
    }

    const handleUpdatedSubFunctionalArea = data => {
        const arr = checkedData(data)
        setSubFunctionalAreaFilterData(arr);
        const filteredCategories = supplierMaintenanceList.filter(item => {
            const currentSubCat = item.props.supplierData.subFunctionalArea.description
            return arr.some(item => currentSubCat.includes(item));
        })
        setFunctionalAreaFilterData(filteredCategories.map(item => item.props.supplierData.functionalArea.description));
    }

    const filterSupplierMaintenanceList = (items) => {
        return items && items.filter((item) => {
            return  functionalAreaFilterData.includes(item.props.supplierData.functionalArea.description)
            && subFunctionalAreaFilterData.includes(item.props.supplierData.subFunctionalArea && item.props.supplierData.subFunctionalArea.description)
            && searchWithDescList(item.props.supplierData, searchParam, searchParamDesc, query)
        })
    }

    const handleViewResults = async () => {
        const selectedSuppliersData = sessionStorage["selectedSuppliers"] ? JSON.parse(sessionStorage.getItem("selectedSuppliers")) : selectedSuppliers;
        const supplierNumbers = selectedSuppliersData ? selectedSuppliersData.map(function (data) {
            return data.supplierNumber;
        }) : [];
        const filterResults = supplierMaintenanceList && supplierMaintenanceList.filter((item)=>{
            return supplierNumbers.includes(item.props.supplierData.supplierNumber)
        })
        supplierNumbers.length > 0 ? setSupplierMaintenanceList(filterResults) : setSupplierMaintenanceList(filterList);
    }

    useEffect(() => {
        getSupplierMaintenanceList().then(res => {
            if (res)
                processSupplierMaintenance(res.data)
            else
                setIsLoading(false)
        });

        return () => {
            setSupplierMaintenanceList(null);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={3}>
                    <Typography variant="h1" component="h1" data-testid="PageName">
                        {name}
                    </Typography>
                </Grid>
                <Grid item xs={9}>
                    <Container>
                        <Box display="flex" justifyContent="flex-end">
                            {isAdmin && (<Link
                                to={{
                                    pathname: "/supplier-mnt/create-ae-supplier",
                                }}
                                style={{ textDecoration: "none" }}
                            >
                                <Button variant="primary" startIcon={<AddIcon />}>
                                    Create New
                                </Button>
                            </Link>)}
                        </Box>
                    </Container>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} md={3}>
                    <Box mt={4}>
                        <Button variant="text-inline" size="large" onClick={resetFilter}>Clear All</Button>
                    </Box>
                    <Box mt={1}>
                        <div className="jdsn-facet-container">
                            <SupplierFilter
                                selectedSuppliers={selectedSuppliers}
                                onOptionsChange={(e) => {
                                    handleSupplierChange(e)
                                }}
                                onExpandClick={handleChangeSupplier}
                                title={"Supplier"}
                                expanded={expandedSupplier}
                            />
                            <FunctionalAreaFilter
                                statusData={functionalAreaData}
                                filteredData={functionalAreaFilterData}
                                onExpandClick={toggleFunctionalAreaFilter}
                                onStatusUpdate={handleUpdatedFuncionalArea}
                                expanded={functionalAreaExpanded}
                                name={"Functional Area"}/>
                            <FunctionalAreaFilter
                                statusData={subFunctionalAreaData}
                                filteredData={subFunctionalAreaFilterData}
                                onExpandClick={toggleSubFunctionalAreaFilter}
                                onStatusUpdate={handleUpdatedSubFunctionalArea}
                                expanded={subFunctionalAreaExpanded}
                                name={"SubFunctional Area"}/>
                            <Box className="fixed-bottom position-sticky view-result">
                                <Button variant="primary" fullWidth={true} size="large" onClick={handleViewResults}>View Results</Button>
                            </Box>
                        </div>
                    </Box>
                </Grid>
                <Grid item xs={12} md={9}>
                    <Container>
                        <Box mt={4}>
                            <FormControl fullWidth>
                                <Input fullWidth placeholder="Filter these results" id="search"
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton aria-label="search">
                                                <SearchIcon style={{ color: " #367c2b" }} />
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    onChange={(e) => setQuery(e.target.value)} />
                            </FormControl>
                        </Box>
                        <Box mt={4}>
                            {isLoading && (
                                <Loading />
                            )}
                            {!isLoading && (
                                <SupplierMaintenanceList list={filterSupplierMaintenanceList(supplierMaintenanceList)} />
                            )}
                        </Box>
                    </Container>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
